<template>
  <naj-modal
    ref="documentModal"
    :width="1500"
    :footer="true"
    :close-button="true"
    :show-footer-close-button="true"
    :title="local.judicialFees.billInvoice"
    @onClose="$emit('documentModalClose')"
  >
    <v-row>
      <div class="preview-holder">
        <div
          v-if="loading"
          class="loader-holder"
        >
          <naj-loader></naj-loader>
        </div>
        <template v-else>
          <div class="attachment-file-viewer pdf-file">
            <div class="pdf-container">
              <div class="pdf-wrapper">
                <div class="pdf-holder">
                  <embed :src="fileUrl">
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </v-row>
  </naj-modal>
</template>

<script>
import { getBlobUrl } from '@/modules/lawsuit/helpers/utils';
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapCaseActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'DocumentModal',
  props: {

    isBase64: {
      type: Boolean,
      default: false,
    },
    base64: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      document: null,
    };
  },
  computed: {
    fileUrl() {
      return getBlobUrl(`data:application/pdf;base64,${this.base64}`, false);
    },
  },
  mounted() {

  },
  methods: {

    closeModal() {
      this.$emit('documentModalClose');
    },

    showModal() {
      this.$refs.documentModal.show();
    },
    hideModal() {
      this.$refs.documentModal.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment-file-viewer {
  height: 100%;
  width: 100%;
}
.preview-holder {
  display: block !important;
  height: 600px;
  width: 100%;
}
.pdf-container {
  height: 100%;
  .pdf-wrapper {
    height: 100%;
    position: relative;
    min-height: 150px;
    .pdf-holder {
      height: inherit;
      text-align: center;
      line-height: 1;
      .pdf-viewer {
        max-height: 100%;
        display: inline-block;
      }
    }
  }
}
.naj-modal-actions {
  justify-content: space-between;
  direction: ltr;
}
embed {
  width: 100%;
  height: 100%;
}
.document-text {
  font-size: 18px;
  line-height: 1.8;
  color: #6d6d6d;
}
</style>
